import { Chip, Row } from "@narmi/design_system";
import styles from "./RecipientDrawer.module.scss";

interface SectionHeaderProps {
  title: string;
  optionalLabel?: string;
  isOpen: boolean;
  checkCondition?: boolean;
  // shown next to the title if provided; used to indicate a badge
  badgeLabel?: string;
}

const SectionHeader = ({
  title,
  optionalLabel,
  isOpen,
  checkCondition = false,
  badgeLabel,
}: SectionHeaderProps) => (
  <Row alignItems="center" className={styles.drawerRow}>
    <Row.Item>
      <h4 className="fontFamily--body">
        {title}
        {optionalLabel ? (
          <span className={styles.optionalLabel}>{optionalLabel}</span>
        ) : null}
      </h4>
      {!isOpen && checkCondition ? <span className="narmi-icon-check" /> : null}
      {badgeLabel ? (
        <span className={styles.sectionBadge}>
          <Chip kind="warn" label={badgeLabel} />
        </span>
      ) : null}
    </Row.Item>
    <Row.Item shrink>
      <span
        className={isOpen ? "narmi-icon-chevron-up" : "narmi-icon-chevron-down"}
      />
    </Row.Item>
  </Row>
);

export default SectionHeader;
